export default "__VITE_ASSET__CLx$f9o4__"